import React, { useState } from 'react';
import CreateWorkflow from '../component/workflow/CreateWorkflowPage'; // The component to show on button click

const WorkflowPage = () => {
  const [showCreateWorkflow, setShowCreateWorkflow] = useState(false);

  const templates = [
    'Lead Gen - Agency',
    'Lead Gen - with pincode',
    'Vehicle Insurance renewal',
    'Vehicle service booking',
  ];

  const workflows = [
    'Untitled Workflow 1717062756885',
    'Lead gen - CTWA',
    '2',
    '1',
    '1-3',
    'rsvp',
  ];

  if (showCreateWorkflow) {
    return <CreateWorkflow />; // Render the other component
  }

  return (
    <div style={{ backgroundColor: '#f5f9f6', fontFamily: 'sans-serif', padding: '20px', minHeight: '100vh' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h2 style={{ color: '#0f5132' }}>Workflow</h2>
        <div>
          <button style={{ marginRight: '10px', padding: '10px 15px', backgroundColor: '#e2e3e5', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
            Workflow Settings
          </button>
          <button
            onClick={() => setShowCreateWorkflow(true)}
            style={{ padding: '10px 15px', backgroundColor: '#00b386', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
          >
            Create new Workflow
          </button>
        </div>
      </div>

      {/* Templates */}
      <div style={{ backgroundColor: '#e8f5ef', borderRadius: '8px', padding: '20px', marginBottom: '20px', border: '1px solid #c8e6c9' }}>
        <p style={{ fontWeight: '500', marginBottom: '10px' }}>
          Looking for a faster and more efficient way to create stunning Workflows? Look no further than our templates!
        </p>
        <div style={{ backgroundColor: 'white', borderRadius: '8px', border: '1px solid #cfd8dc', overflow: 'hidden' }}>
          {templates.map((template, i) => (
            <div
              key={i}
              style={{
                padding: '10px 15px',
                borderBottom: i < templates.length - 1 ? '1px solid #e0e0e0' : 'none',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <span style={{ color: '#1b5e20' }}>{template}</span>
              {template.includes('pincode') && <span style={{ fontSize: '14px', color: '#757575' }}>✏️</span>}
            </div>
          ))}
        </div>
      </div>

      {/* Workflows */}
      <div>
        <h3 style={{ marginBottom: '10px', fontWeight: '600' }}>Workflows created by you</h3>
        <div style={{ backgroundColor: 'white', borderRadius: '8px', border: '1px solid #cfd8dc' }}>
          {workflows.map((workflow, i) => (
            <div key={i} style={{ padding: '10px 15px', borderBottom: i < workflows.length - 1 ? '1px solid #e0e0e0' : 'none', color: '#37474f' }}>
              {workflow}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkflowPage;
